<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑机构管理员</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">登录账号</div>
                        <el-input v-model="edit_loginName" placeholder="请输入登录账号" disabled></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">姓名</div>
                        <el-input v-model="edit_realName" placeholder="请输入姓名"></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">手机</div>
                        <el-input v-model="edit_phone" maxlength="11"  placeholder="请输入手机"></el-input>
                    </el-col>

                    <el-col :span="12" class="item">
                        <div class="label">职工状态</div>
                        <el-select v-model="edit_status" placeholder="选择状态" @change="changeStatus" style="width:100%">
                            <el-option
                                    v-for="item in status2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">选择机构</div>
                        <el-select v-model="edit_institutionCode" placeholder="选择机构" @change="changeInstitution" style="width:100%">
                            <el-option
                                    v-for="item in institutionList"
                                    :key="item.institutionCode"
                                    :label="item.name"
                                    :value="item.institutionCode">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">选择角色</div>
                        <el-select v-model="edit_roleCode" placeholder="选择角色" @change="changeRole" style="width:100%">
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.roleCode"
                                    :label="item.name"
                                    :value="item.roleCode">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Edit",
        props: ['institutionList'],
        data() {
            return {

                loading: false,

                edit_loginName:'',
                edit_realName:'',
                edit_phone:'',

                edit_staffCode:'',

                edit_institutionCode:'',
                edit_roleCode:'',

                // institutionList:null,
                roleList:null,

                status2: [{
                    value: 0,
                    label: '默认'
                }, {
                    value: 1,
                    label: '已通过'
                }, {
                    value: 2,
                    label: '被禁用'
                }],
                edit_status: 0,
                // insAlways:true

            }
        },
        methods: {
            init(row){
                console.log("Edit init");

                this.edit_loginName = row.loginName;
                this.edit_realName = row.realName;
                this.edit_phone = row.phone;
                this.edit_status = row.status;
                this.edit_staffCode = row.staffCode;
                this.edit_roleCode= row.roleCode;
                // this.getInstitutionList(row.institutionCode);
                this.changeInstitution(row.institutionCode)
            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            changeStatus:function (selVal) {
                this.edit_status = selVal;
            },



            confirm(){

                if(this.edit_loginName == ''){
                    return;
                }
                // if(this.edit_roleCode == ''){
                //     return;
                // }
                if(this.edit_realName == ''){
                    return;
                }
                if(this.edit_phone == ''){
                    return;
                }
                if(this.edit_institutionCode == ''){
                    return;
                }
                if(this.edit_roleCode == ''){
                    return;
                }

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Staff/EditIns',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),

                        loginName: this.edit_loginName,
                        realName:this.edit_realName,
                        phone:this.edit_phone,
                        status:this.edit_status,

                        institutionCode:this.edit_institutionCode,
                        roleCode:this.edit_roleCode,

                        staffCode1:this.edit_staffCode,

                    }
                }).then( (response)=> {
                    console.log(response);
                    this.loading = false;

                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                    }else{
                        this.$message(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },




            changeInstitution:function(selVal){
                this.edit_institutionCode = selVal;
                let insAlways="机构管理员"
                this.institutionList.forEach(element => {
                    if(element.institutionCode==selVal && element.isChain ==1){
                        switch(element.chainType){
                            case 'parent':
                                insAlways="总机构管理员"
                                break;
                            case 'middle':
                                insAlways="区域经理"
                                break;
                            default:
                                break;
                        }
                    }
                });
                this.getRoleList(selVal,insAlways);
            },

            changeRole:function (selVal) {
                this.edit_roleCode = selVal;
            },

            getRoleList(selVal,roleName){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'RoleInstitution/ListForAdmin',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        institutionCode:selVal
                    }
                }).then((response)=> {
                    if(response.data.error == 0){
                        var roleList=response.data.data.listRoleDTO;
                        this.edit_roleCode=''
                        roleList.forEach(element => {
                            if(element.name==roleName){
                                this.edit_roleCode = element.roleCode
                            }
                        });
                        this.roleList =roleList
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style scoped>

</style>
